import React from 'react'
import * as styles from './break.module.css'

const Break = () => {
  return <hr className={styles.break} />
}

export default Break
